import {
  fetchDepartmentDescription,
  fetchLayerDepartmentDescription,
  fetchLayerRegionDescription,
  fetchRegionDescription
} from '../../dataSource/seo/seo.request'
import { selectFirstAddress, selectZone } from '../address/address.selectors'

import PermanentRedirectError from '../../domain/error/PermanentRedirectError'
import { generateFullRoute } from '../../domain/router/routeUtils'
import { loadDescription } from '../address/addressSlice'

export const redirectLayerRegionRouteIfTownUpperCased = (regionCode, region, route) => {
  if (region.toLowerCase() !== region)
    throw new PermanentRedirectError(
      generateFullRoute(route, {
        location: `${regionCode}-${region.toLowerCase()}`
      })
    )
}

export const redirectLayerDepartmentRouteIfTownUpperCased = (departmentCode, department, route) => {
  if (department.toLowerCase() !== department)
    throw new PermanentRedirectError(
      generateFullRoute(route, {
        location: `${departmentCode}-${department.toLowerCase()}`
      })
    )
}

export const searchDepartmentDescription = () => (dispatch, getState) => {
  const address = selectFirstAddress(getState())
  const { countryCode, departmentCode } = address
  return fetchDepartmentDescription({ countryCode, zoneCode: departmentCode })
    .then(({ description }) => {
      if (description) {
        dispatch(loadDescription(description))
      }
    })
    .catch(e => console.warn(`searchDepartmentDescription: no zone description for ${countryCode}-${departmentCode}`))
}

export const searchRegionDescription = () => (dispatch, getState) => {
  const address = selectFirstAddress(getState())
  const { countryCode, regionCode } = address
  return fetchRegionDescription({ countryCode, zoneCode: regionCode })
    .then(({ description }) => {
      if (description) {
        dispatch(loadDescription(description))
      }
    })
    .catch(e => console.warn(`searchRegionDescription: no zone description for ${countryCode}-${regionCode}`))
}

export const searchLayerZoneDescription = layer => (dispatch, getState) => {
  const { countryCode, code, isDepartment } = selectZone(getState())
  const fetchMethod = isDepartment ? fetchLayerDepartmentDescription : fetchLayerRegionDescription
  return fetchMethod({ countryCode, zoneCode: code, layer }).then(({ description }) => {
    if (description) {
      dispatch(loadDescription(description))
    }
  })
}
